import {
    getField
} from 'vuex-map-fields';

export default {
    getLoginField(state) {
        return getField(state.login);
    },
    getRegisterField(state) {
        return getField(state.register);
    },
    getResetPasswordField(state) {
        return getField(state.reset_password);
    }
}